import {
  GetAddresses,
  CreateAddress,
  UpdateAddress,
  DeleteAddress,
  getUserAddress,
} from "../../Services/MainServices";
import { toast } from "react-toastify";

export const FETCH_ADDRESSES_REQUEST = "FETCH_ADDRESSES_REQUEST";
export const FETCH_ADDRESSES_SUCCESS = "FETCH_ADDRESSES_SUCCESS";
export const FETCH_ADDRESSES_FAILURE = "FETCH_ADDRESSES_FAILURE";

export const ADD_ADDRESS_SUCCESS = "ADD_ADDRESS_SUCCESS";
export const UPDATE_ADDRESS_SUCCESS = "UPDATE_ADDRESS_SUCCESS";
export const DELETE_ADDRESS_SUCCESS = "DELETE_ADDRESS_SUCCESS";

export const GET_ADDRESS_REQUEST = "GET_ADDRESS_REQUEST";
export const GET_ADDRESS_SUCCESS = "GET_ADDRESS_SUCCESS";
export const GET_ADDRESS_FAILURE = "GET_ADDRESS_FAILURE";

export const fetchAddresses = () => async (dispatch) => {
  dispatch({ type: FETCH_ADDRESSES_REQUEST });

  try {
    const response = await GetAddresses();

    // HTTP status check
    if (response.status !== 200) {
      throw new Error("Network error. Try again later.");
    }

    // Backend-level status check
    const resData = response.data;
    if (resData.status !== "success") {
      throw new Error(resData.message || "Failed to fetch addresses.");
    }

    // Safe address extraction
    const addresses = response.data.data;
    dispatch({ type: FETCH_ADDRESSES_SUCCESS, payload: addresses });

    // If exactly one and it's not default on the backend, set it:
    if (addresses.length === 1 && !addresses[0].is_default) {
      const pk = addresses[0].id ?? addresses[0].address_id;
      dispatch(updateAddress(pk, { ...addresses[0], is_default: true }));
    }
  } catch (error) {
    const status = error?.response?.status;
    const message =
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to fetch addresses.";

    // toast.error(message);

    if (status === 401) {
      // Optional: handle token expiration / logout
    }

    dispatch({ type: FETCH_ADDRESSES_FAILURE, payload: message });
  }
};

// Create a new address
export const addAddress = (addressData) => async (dispatch) => {
  try {
    const response = await CreateAddress(addressData);

    if (response.status === 201 && response.data.status === "success") {
      dispatch({ type: ADD_ADDRESS_SUCCESS, payload: response.data.data });
      return { success: true, data: response.data.data };
    } else {
      const msg = response.data?.message || "Unexpected response from server.";
      return { success: false, error: msg };
    }
  } catch (error) {
    const status = error.response?.status;
    const backendMsg =
      error.response?.data?.detail || error.response?.data?.message;
    const message = backendMsg || "Server error when adding address.";

    if (status === 401) {
      toast.error("Session expired. Please log in again.");
      // Optional: dispatch(logout());
    }

    return { success: false, error: message };
  }
};

export const updateAddress = (id, updatedData) => async (dispatch) => {
  try {
    const response = await UpdateAddress(id, updatedData);
    if (response.status === 200 && response.data.status === "success") {
      dispatch({ type: UPDATE_ADDRESS_SUCCESS, payload: response.data.data });
      toast.success("Address updated successfully!");
    } else {
      toast.error(response.data.message || "Failed to update address.");
    }
  } catch (error) {
    toast.error(error.response?.data?.detail || "Server error when updating.");
  }
};

export const deleteAddress = (id) => async (dispatch) => {
  try {
    const response = await DeleteAddress(id);
    if (
      response.status === 204 ||
      (response.status === 200 && response.data.status === "success")
    ) {
      dispatch({ type: DELETE_ADDRESS_SUCCESS, payload: id });
      toast.success("Address deleted successfully!");
    } else {
      toast.error(response.data.message || "Failed to delete address.");
    }
  } catch (error) {
    toast.error(error.response?.data?.detail || "Server error when deleting.");
  }
};

export const getAddressList = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ADDRESS_REQUEST });

    const response = await getUserAddress();

    if (response?.data?.status == "success") {
      dispatch({
        type: GET_ADDRESS_SUCCESS,
        payload: response?.data?.data, // array of user addresses
      });
    } else {
      dispatch({
        type: GET_ADDRESS_FAILURE,
        error: response.message || "Failed to fetch addresses",
      });
    }
  } catch (error) {
    dispatch({
      type: GET_ADDRESS_FAILURE,
      error: error.message || "Something went wrong",
    });
  }
};
